import Overview from '@/features/reports/rank-zone/overview/Overview'
// import Competition from '@/features/reports/rank-zone/competition/Competition'
import Competition from '@/features/reports/rank-zone/competition/Competition'
import Progress from '@/features/reports/rank-zone/progress/Progress'
import Sections from '@/features/reports/rank-zone/sections/Sections'
import Status from '@/features/reports/rank-zone/status/Status'
import Url from '@/features/reports/rank-zone/url/Url'

export default [
  {
    path: 'overview',
    name: 'Overview',
    component: Overview,
    redirect: 'progress' // deprecate Overview page
  },
  {
    path: 'progress',
    name: 'Progress',
    component: Progress
  },
  {
    path: 'comparison',
    name: 'Comparison',
    component: Competition
  },
  {
    path: 'sections',
    name: 'Sections',
    component: Sections
  },
  {
    path: 'status',
    name: 'Status',
    component: Status
  },
  {
    path: 'url',
    name: 'URL',
    component: Url
  }
]
